<template>
  <div class="step-item">
    <div class="step-border">
      <div class="step-number">
        <span class="step">STEP</span>
        <span class="number">{{ number }}</span>
      </div>
      <div class="border"></div>
    </div>
    <div class="step-textimage">
      <div class="step-text" :class="$parent.type">
        <div class="container">
          <div class="row">
            <h4 class="heading col-md-12">
              {{ title
              }}<span v-if="badge" class="badge"
                ><BadgeIcon class="-md -requires">{{ badge }}</BadgeIcon></span
              >
            </h4>
          </div>
          <div v-if="is_tem" class="row">
            <div class="col-md-12">
              <slot></slot>
            </div>
          </div>
          <div v-else-if="is_sv" class="row">
            <div class="col-md-5 col-12">
              <img :src="image_src" class="img-fluid" alt="" />
            </div>
            <div class="col-md-7 col-12 text">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      <div v-if="is_tem" class="step-image">
        <img :src="image_src" class="img-fluid" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import BadgeIcon from "@/components/badges/BadgeIcon";
export default {
  name: "StepItem",
  components: { BadgeIcon },
  props: {
    number: { type: String, default: "" },
    title: { type: String, default: "" },
    badge: { type: String, default: "" },
    src: { type: String, default: "" },
    srcSp: { type: String, default: "" },
  },
  data() {
    return {
      width: { type: Number },
    };
  },
  computed: {
    image_src() {
      let req = require("@/assets/images/" + this.src);
      if (this.width < 768 && this.srcSp) {
        req = require("@/assets/images/" + this.srcSp);
      }
      return req;
    },
    is_tem() {
      return this.$parent.type === "tem";
    },
    is_sv() {
      return this.$parent.type === "sv";
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize, false);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize, false);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.step-item {
  .-orange & {
    .step-number {
      background-color: $orange;
    }
  }
  .-green & {
    .step-number {
      background-color: $green;
    }
  }
  @include flex(flex, flex-start, stretch, row, nowrap);
  > .step-border {
    @include flex(flex, center, stretch, row, nowrap);
    position: relative;
    > .step-number {
      @include flex(flex, center, center, column, nowrap);
      border-radius: 5px;
      color: $white;
      width: 40px;
      height: 40px;
      @include mq-up(md) {
        border-radius: 10px;
        width: 70px;
        height: 70px;
      }
      > .step {
        font-size: 9px;
        @include mq-up(md) {
          font-size: 16px;
          line-height: 18px;
        }
      }
      > .number {
        font-size: 16px;
        font-weight: bold;
        @include mq-up(md) {
          font-size: 24px;
          line-height: 28px;
        }
      }
    }
    > .border {
      position: absolute;
      background-color: $secondary;
      display: block;
      height: calc(100% - 40px);
      width: 2px;
      top: 40px;
      @include mq-up(md) {
        height: calc(100% - 70px);
        top: 70px;
        left: 50%;
      }
    }
  }
  &.-sm {
    > .step-border {
      > .step-number {
        width: 35px;
        height: 35px;
        @include mq-up(md) {
          border-radius: 10px;
          width: 50px;
          height: 50px;
        }
        > .step {
          font-size: 10px;
          @include mq-up(md) {
            font-size: 12px;
          }
        }
        > .number {
          font-size: 16px;
          font-weight: bold;
          @include mq-up(md) {
            font-size: 20px;
          }
        }
      }
      > .border {
        height: calc(100% - 35px);
        top: 35px;
        @include mq-up(md) {
          height: calc(100% - 50px);
          top: 50px;
        }
      }
    }
  }
  > .step-textimage {
    @include flex(flex, flex-start, flex-start, row, wrap);
    padding: 0 0 50px 15px;
    width: calc(100% - 35px);
    @include mq-up(md) {
      width: calc(100% - 50px);
    }
    > .step-text {
      width: 100%;
      .heading {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 25px;
        > .badge {
          padding-left: 10px;
        }
        @include mq-up(md) {
          font-size: 24px;
          padding-top: 14px;
          margin-bottom: 40px;
          > .badge {
            padding-left: 40px;
          }
        }
      }
      .text {
        @include mq-down(md) {
          padding-top: 10px;
        }
      }
      &.tem {
        @include mq-up(md) {
          width: 85%;
          padding: 0 110px 0 0px;
        }
        .heading {
          @include mq-up(md) {
            padding-top: 8px;
            margin-bottom: 10px;
          }
        }
      }
      > .container {
        > .row {
          > .col-12 {
            @include mq-down(md) {
              padding-left: 0;
              padding-right: 0;
            }
          }
        }
      }
    }
    > .step-image {
      width: 100%;
      padding: 0 15px;
      @include mq-up(md) {
        width: 15%;
        padding: 0;
      }
    }
  }
  &.-last {
    > .step-border {
      > .border {
        &:after {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          bottom: 0;
          margin: 0;
          left: -9px;
          border-style: solid;
          border-width: 0 10px 10px 10px;
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
          border-color: transparent transparent #cccccc transparent;
        }
      }
    }
  }
}
</style>
